import React from "react";
import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/Container";
import styled from "styled-components";
import { SchoolTeacher, SchoolStudent } from "../../common/api";
import { labelForTeacher } from "./TeacherSelector";
import { labelForStudent } from "../assignments/StudentSelector";
import { COLOR_GRAY_MUTED, COLOR_TEXT_PRIMARY } from "../../common/colors";

const SectionTitleText = styled.span`
  color: ${COLOR_GRAY_MUTED};
`;

const SectionElementText = styled.span`
  color: ${COLOR_TEXT_PRIMARY};
`;

export const ConfirmCustomGroup: React.FC<{
  customSectionName: string;
  setCustomSectionName: (name: string) => void;
  selectedStudents: SchoolStudent[];
  selectedTeachers: SchoolTeacher[];
  onClickConfirm: () => void;
  showDelete: boolean;
  onClickDelete: () => void;
}> = ({
  customSectionName,
  setCustomSectionName,
  selectedStudents,
  selectedTeachers,
  onClickConfirm,
  showDelete,
  onClickDelete,
}) => {
  const { t } = useTranslation();

  return (
    <Container
      className="my-5 d-flex align-items-center gap-4 flex-column"
      style={{ maxWidth: "800px" }}
    >
      <div className="row">
        <div className="d-flex align-items-baseline gap-2">
          <label htmlFor="customSectionName" className="form-label">
            {t("create_instructional_group_name_label")}
          </label>
          <input
            type="text"
            className="form-control"
            id="customSectionName"
            placeholder={t("create_instructional_group_name_input_placeholder")}
            value={customSectionName}
            onChange={(e) => setCustomSectionName(e.target.value)}
          />
        </div>
      </div>
      <div className="row">
        <div className="d-flex align-items-center flex-column">
          <div className="mb-2">
            <SectionTitleText>
              {t("create_instructional_group_student_title")}
            </SectionTitleText>
          </div>
          {selectedStudents.map((student) => (
            <div key={`student-${student.id}`}>
              <SectionElementText>
                {labelForStudent(student)}
              </SectionElementText>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="d-flex align-items-center flex-column">
          <div className="mb-2">
            <SectionTitleText>
              {t("create_instructional_group_teacher_title")}
            </SectionTitleText>
          </div>
          {selectedTeachers.map((teacher) => (
            <div key={`teacher-${teacher.id}`}>
              <SectionElementText>
                {labelForTeacher(teacher)}
              </SectionElementText>
            </div>
          ))}
        </div>
      </div>
      <div className="d-flex gap-2 flex-column">
        <div>
          <button
            className="btn btn-primary rounded-pill px-4"
            disabled={customSectionName.length <= 0}
            onClick={() => onClickConfirm()}
          >
            {showDelete ? (
              <>{t("save_changes_instructional_group_button")}</>
            ) : (
              <>{t("create_instructional_group_button")}</>
            )}
          </button>
        </div>
        {showDelete && (
          <div>
            <button
              className="btn btn-outline-danger rounded-pill px-4"
              disabled={customSectionName.length <= 0}
              onClick={() => onClickDelete()}
            >
              {t("delete_instructional_group_button")}
            </button>
          </div>
        )}
      </div>
    </Container>
  );
};
